import React from 'react';
import cn from 'classnames';
import styles from './Parameter.module.scss';

const Parameter = ({ className, title, text, list, addBackground = false, children }) => {
  return (
    <div
      className={cn(styles.wrapper, className, {
        [styles.descAndCommentWrapper]: addBackground,
      })}
    >
      <p className={styles.title}>{title}</p>
      {text && <p className={styles.text}>{text}</p>}
      {list && (
        <ul className={styles.list}>
          {list.map((item) => (
            <li key={item.id}>{item.shortName}</li>
          ))}
        </ul>
      )}
      {children}
    </div>
  );
};

export default Parameter;
